(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["insta-reel"] && !Shopify.designMode) return;
  try {
    
// insta-reel:js:start
(function () {
  if (!('customElements' in window) || window.customElements.get('insta-reel')) return;

  var REDUCED_MOTION = '(prefers-reduced-motion: reduce)';
  var FINE_POINTER = '(hover: hover) and (pointer: fine)';
  var NEAR_MARGIN = '800px 0px';
  var MAX_SETS = 40;

  class InstaReel extends HTMLElement {
    static get observedAttributes() {
      return ['data-mode', 'data-speed'];
    }

    constructor() {
      super();
      this.ready = false;
      this.state = '';
      this.userPaused = false;
      this.onScreen = true;
      this.nearViewport = false;
      this.touching = false;
      this.setWidth = 0;
      this.sets = 0;
      this.duration = 0;
      this.lastWidth = 0;
      this.fullBuildPending = false;
      this.videos = [];
      this.pauseReasons = new Set();
      this.holdReasons = new Set();
      this.visibleVideos = new Set();
      this.handlers = {
        pointerEnter: (event) => {
          if (event.pointerType !== 'touch') this.pause('hover');
        },
        pointerLeave: (event) => {
          if (event.pointerType !== 'touch') this.resume('hover');
        },
        focusIn: (event) => this.onFocusIn(event),
        focusOut: (event) => this.onFocusOut(event),
        touchStart: () => this.onTouchStart(),
        touchEnd: () => this.onTouchEnd(),
        scroll: () => this.onScroll(),
        toggle: () => this.setUserPaused(!this.userPaused),
        prev: () => this.step(-1),
        next: () => this.step(1),
        iteration: (event) => {
          if (event.target === this.track) this.syncVideos();
        },
        playing: (event) => {
          if (event.target && event.target.tagName === 'VIDEO') event.target.setAttribute('data-started', '');
        },
        motionChange: () => {
          this.userPaused = this.motionQuery.matches;
          this.build();
        },
        pointerChange: () => this.updateArrows(),
        windowResize: () => this.scheduleBuild(180, true)
      };
    }

    connectedCallback() {
      if (document.readyState === 'loading' && !this.querySelector('.insta-reel__track')) {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        return;
      }
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (!this.ready || oldValue === newValue) return;
      if (name === 'data-speed') {
        this.updateSpeed();
      } else {
        this.scheduleBuild(0, false);
      }
    }

    init() {
      if (this.ready) return;
      this.viewport = this.querySelector('.insta-reel__viewport');
      this.track = this.querySelector('.insta-reel__track');
      if (!this.viewport || !this.track) return;
      this.originals = Array.prototype.filter.call(this.track.children, (child) => !child.hasAttribute('data-ir-clone'));
      if (!this.originals.length) return;

      this.controls = this.querySelector('.insta-reel__controls');
      this.toggleButton = this.querySelector('.insta-reel__toggle');
      this.prevButton = this.querySelector('.insta-reel__arrow--prev');
      this.nextButton = this.querySelector('.insta-reel__arrow--next');
      this.motionQuery = window.matchMedia(REDUCED_MOTION);
      this.pointerQuery = window.matchMedia(FINE_POINTER);
      this.userPaused = this.motionQuery.matches;
      this.nearViewport = !('IntersectionObserver' in window);
      this.ready = true;
      this.setAttribute('data-ready', '');

      const h = this.handlers;
      this.viewport.addEventListener('pointerenter', h.pointerEnter);
      this.viewport.addEventListener('pointerleave', h.pointerLeave);
      this.viewport.addEventListener('focusin', h.focusIn);
      this.viewport.addEventListener('focusout', h.focusOut);
      this.viewport.addEventListener('touchstart', h.touchStart, { passive: true });
      this.viewport.addEventListener('touchend', h.touchEnd, { passive: true });
      this.viewport.addEventListener('touchcancel', h.touchEnd, { passive: true });
      this.viewport.addEventListener('scroll', h.scroll, { passive: true });
      this.track.addEventListener('animationiteration', h.iteration);
      this.track.addEventListener('playing', h.playing, true);
      if (this.toggleButton) this.toggleButton.addEventListener('click', h.toggle);
      if (this.prevButton) this.prevButton.addEventListener('click', h.prev);
      if (this.nextButton) this.nextButton.addEventListener('click', h.next);
      this.motionQuery.addEventListener('change', h.motionChange);
      this.pointerQuery.addEventListener('change', h.pointerChange);

      if ('IntersectionObserver' in window) {
        // The copies (and every image in them) are only made once the reel is close to the screen.
        this.nearObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.nearObserver.disconnect();
          this.nearViewport = true;
          this.build();
        }, { rootMargin: NEAR_MARGIN });
        this.nearObserver.observe(this);

        this.sectionObserver = new IntersectionObserver((entries) => {
          this.onScreen = entries[entries.length - 1].isIntersecting;
          if (this.onScreen) {
            this.resume('offscreen');
          } else {
            this.pause('offscreen');
          }
          this.updateVideos();
        }, { rootMargin: '120px 0px' });
        this.sectionObserver.observe(this);

        this.videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
              this.visibleVideos.add(entry.target);
            } else {
              this.visibleVideos.delete(entry.target);
            }
          });
          this.updateVideos();
        }, { threshold: [0, 0.2, 0.6] });
      }

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          if (Math.round(this.viewport.clientWidth) !== this.lastWidth) this.scheduleBuild(180, true);
        });
        this.resizeObserver.observe(this.viewport);
      } else {
        window.addEventListener('resize', h.windowResize);
      }

      this.build();
    }

    destroy() {
      if (!this.ready) return;
      this.ready = false;
      clearTimeout(this.buildTimer);
      clearTimeout(this.touchTimer);
      this.fullBuildPending = false;
      if (this.arrowFrame) cancelAnimationFrame(this.arrowFrame);
      this.arrowFrame = 0;

      const h = this.handlers;
      this.viewport.removeEventListener('pointerenter', h.pointerEnter);
      this.viewport.removeEventListener('pointerleave', h.pointerLeave);
      this.viewport.removeEventListener('focusin', h.focusIn);
      this.viewport.removeEventListener('focusout', h.focusOut);
      this.viewport.removeEventListener('touchstart', h.touchStart);
      this.viewport.removeEventListener('touchend', h.touchEnd);
      this.viewport.removeEventListener('touchcancel', h.touchEnd);
      this.viewport.removeEventListener('scroll', h.scroll);
      this.track.removeEventListener('animationiteration', h.iteration);
      this.track.removeEventListener('playing', h.playing, true);
      if (this.toggleButton) this.toggleButton.removeEventListener('click', h.toggle);
      if (this.prevButton) this.prevButton.removeEventListener('click', h.prev);
      if (this.nextButton) this.nextButton.removeEventListener('click', h.next);
      this.motionQuery.removeEventListener('change', h.motionChange);
      this.pointerQuery.removeEventListener('change', h.pointerChange);
      window.removeEventListener('resize', h.windowResize);
      if (this.nearObserver) this.nearObserver.disconnect();
      if (this.sectionObserver) this.sectionObserver.disconnect();
      if (this.videoObserver) this.videoObserver.disconnect();
      if (this.resizeObserver) this.resizeObserver.disconnect();

      this.videos.forEach((video) => {
        if (!video.paused) video.pause();
      });
      this.removeClones();
      this.videos = [];
      this.pauseReasons.clear();
      this.holdReasons.clear();
      this.visibleVideos.clear();
      this.state = '';
      this.nearViewport = false;
      this.setWidth = 0;
      this.sets = 0;
      ['data-ready', 'data-state', 'data-paused', 'data-user-paused', 'data-overflow'].forEach((name) => this.removeAttribute(name));
      ['--ir-shift', '--ir-duration', '--ir-delay'].forEach((name) => this.style.removeProperty(name));
      this.track.style.removeProperty('animation');
      this.viewport.scrollLeft = 0;
      if (this.controls) this.controls.hidden = true;
    }

    scheduleBuild(delay, refitOnly) {
      if (!refitOnly) this.fullBuildPending = true;
      clearTimeout(this.buildTimer);
      this.buildTimer = setTimeout(() => {
        if (this.fullBuildPending) {
          this.build();
        } else {
          this.refit();
        }
      }, delay);
    }

    setState(state) {
      this.state = state;
      this.setAttribute('data-state', state);
    }

    build() {
      if (!this.ready || !this.nearViewport) return;
      clearTimeout(this.buildTimer);
      clearTimeout(this.touchTimer);
      this.fullBuildPending = false;

      // Keep the position through a rebuild (new width, drawer scrollbar, speed or mode change).
      const previous = this.state;
      let progress = -1;
      if ((previous === 'marquee' || previous === 'held') && this.setWidth > 0) {
        const travelled = previous === 'held' ? Math.abs(this.viewport.scrollLeft) : Math.abs(this.currentOffset());
        progress = (travelled % this.setWidth) / this.setWidth;
      }
      const manualScroll = previous === 'manual' ? this.viewport.scrollLeft : 0;

      this.touching = false;
      this.holdReasons.delete('touch');
      if (this.userPaused) {
        this.holdReasons.add('user');
      } else {
        this.holdReasons.delete('user');
      }
      this.setState('manual');
      this.removeClones();
      this.viewport.scrollLeft = 0;
      this.lastWidth = Math.round(this.viewport.clientWidth);
      this.setWidth = 0;
      this.sets = 0;

      const wantsMarquee = this.getAttribute('data-mode') === 'auto' && !this.motionQuery.matches;
      if (wantsMarquee) this.buildMarquee(progress);
      if (this.state === 'manual' && manualScroll) this.viewport.scrollLeft = manualScroll;

      this.observeVideos();
      this.updateToggle();
      this.applyPaused();
      this.updateArrows();
      this.updateVideos();
    }

    refit() {
      if (!this.ready || !this.nearViewport) return;
      const width = Math.round(this.viewport.clientWidth);
      if (width === this.lastWidth) return;
      if ((this.state === 'marquee' || this.state === 'held') && this.setWidth > 0) {
        const setWidth = this.measureSet();
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        if (Math.abs(setWidth - this.setWidth) < 0.05 && this.sets >= this.setsFor(setWidth, width, gap)) {
          this.lastWidth = width;
          this.updateArrows();
          return;
        }
      }
      this.build();
    }

    setsFor(setWidth, viewportWidth, gap) {
      return Math.min(MAX_SETS, Math.max(
        2,
        Math.ceil((setWidth + viewportWidth + gap) / setWidth),
        Math.ceil((2 * viewportWidth) / setWidth)
      ));
    }

    buildMarquee(progress) {
      const setWidth = this.measureSet();
      const viewportWidth = this.viewport.clientWidth;
      if (setWidth < 1 || viewportWidth < 1) return;

      const trackStyles = getComputedStyle(this.track);
      const gap = parseFloat(trackStyles.columnGap) || 0;
      const edge = parseFloat(trackStyles.paddingLeft) || 0;
      const sets = this.setsFor(setWidth, viewportWidth, gap);
      const fragment = document.createDocumentFragment();
      for (let i = 1; i < sets; i += 1) {
        this.originals.forEach((item) => fragment.appendChild(this.makeClone(item)));
      }
      this.track.appendChild(fragment);

      // The moving track has no side padding. It starts one set minus the page gutter in,
      // so the first tile still lines up with the page while the previous copy fills the gutter.
      const distance = progress >= 0 ? progress * setWidth : (((setWidth - edge) % setWidth) + setWidth) % setWidth;
      const rtl = getComputedStyle(this).direction === 'rtl';
      this.setWidth = setWidth;
      this.sets = sets;
      this.duration = setWidth / this.readSpeed();
      this.style.setProperty('--ir-shift', (rtl ? setWidth : -setWidth).toFixed(2) + 'px');
      this.style.setProperty('--ir-duration', this.duration.toFixed(3) + 's');
      this.style.setProperty('--ir-delay', (-(distance / setWidth) * this.duration).toFixed(3) + 's');
      void this.track.offsetWidth;
      this.setState('marquee');
      if (this.holdReasons.size) this.enterHold();
    }

    layoutScale() {
      // Rects include ancestor transforms (e.g. the theme's zoom-in animation); layout sizes do not.
      const rendered = this.track.getBoundingClientRect().width;
      const layout = parseFloat(getComputedStyle(this.track).width);
      return rendered > 0 && layout > 0 ? rendered / layout : 1;
    }

    measureSet() {
      const first = this.originals[0].getBoundingClientRect();
      const last = this.originals[this.originals.length - 1].getBoundingClientRect();
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const span = (Math.max(first.right, last.right) - Math.min(first.left, last.left)) / this.layoutScale();
      return span > 0 ? span + gap : 0;
    }

    makeClone(item) {
      const clone = item.cloneNode(true);
      clone.setAttribute('data-ir-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      [clone].concat(Array.prototype.slice.call(clone.querySelectorAll('*'))).forEach((element) => {
        element.removeAttribute('id');
        element.removeAttribute('data-started');
        Array.prototype.slice.call(element.attributes).forEach((attribute) => {
          if (attribute.name.indexOf('data-shopify-editor') === 0) element.removeAttribute(attribute.name);
        });
      });
      // Copies stay clickable for mouse and touch, but are skipped by the keyboard and screen readers.
      clone.querySelectorAll('a, button, video, input, select, textarea, [tabindex]').forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });
      return clone;
    }

    removeClones() {
      Array.prototype.slice.call(this.track.children).forEach((child) => {
        if (!child.hasAttribute('data-ir-clone')) return;
        child.querySelectorAll('video').forEach((video) => {
          if (!video.paused) video.pause();
        });
        child.remove();
      });
    }

    readSpeed() {
      const speed = parseFloat(this.getAttribute('data-speed'));
      return Math.min(400, Math.max(5, isNaN(speed) ? 40 : speed));
    }

    currentOffset() {
      const transform = getComputedStyle(this.track).transform;
      if (!transform || transform === 'none') return 0;
      try {
        return new DOMMatrixReadOnly(transform).m41;
      } catch (error) {
        return 0;
      }
    }

    applyTiming(duration, distance) {
      this.duration = duration;
      this.style.setProperty('--ir-duration', duration.toFixed(3) + 's');
      this.style.setProperty('--ir-delay', (-(distance / this.setWidth) * duration).toFixed(3) + 's');
      this.track.style.animation = 'none';
      void this.track.offsetWidth;
      this.track.style.removeProperty('animation');
    }

    updateSpeed() {
      if (!this.setWidth) return;
      const duration = this.setWidth / this.readSpeed();
      if (this.state === 'marquee') {
        this.applyTiming(duration, Math.abs(this.currentOffset()) % this.setWidth);
      } else if (this.state === 'held') {
        this.duration = duration;
        this.style.setProperty('--ir-duration', duration.toFixed(3) + 's');
      }
    }

    hold(reason) {
      this.holdReasons.add(reason);
      if (this.state === 'marquee') this.enterHold();
    }

    enterHold() {
      const offset = this.currentOffset();
      this.setState('held');
      this.viewport.scrollLeft = -offset;
      this.updateArrows();
    }

    release(reason) {
      if (!this.holdReasons.delete(reason) || this.holdReasons.size || this.state !== 'held') return;
      const distance = Math.abs(this.viewport.scrollLeft) % this.setWidth;
      this.applyTiming(this.duration, distance);
      this.viewport.scrollLeft = 0;
      this.setState('marquee');
      this.updateArrows();
    }

    pause(reason) {
      this.pauseReasons.add(reason);
      this.applyPaused();
    }

    resume(reason) {
      this.pauseReasons.delete(reason);
      this.applyPaused();
    }

    applyPaused() {
      this.toggleAttribute('data-paused', this.userPaused || this.pauseReasons.size > 0);
    }

    setUserPaused(value) {
      this.userPaused = value;
      this.toggleAttribute('data-user-paused', value);
      // A paused reel becomes scrollable (arrows on desktop) and resumes from where the visitor left it.
      if (value) {
        this.hold('user');
      } else {
        this.release('user');
      }
      this.applyPaused();
      this.updateToggle();
      this.updateArrows();
      this.updateVideos();
    }

    updateToggle() {
      this.toggleAttribute('data-user-paused', this.userPaused);
      const button = this.toggleButton;
      if (!button) return;
      const moving = this.state === 'marquee' || this.state === 'held';
      button.hidden = !(moving || this.videos.length > 0);
      // Without movement the button only controls the videos, so it says so.
      const kind = moving ? '' : 'Video';
      const label = (key) => button.dataset[key + kind] || button.dataset[key] || '';
      const text = button.querySelector('.insta-reel__toggle-text');
      if (text) text.textContent = label(this.userPaused ? 'labelPlay' : 'labelPause');
      button.setAttribute('aria-label', label(this.userPaused ? 'a11yPlay' : 'a11yPause'));
    }

    updateArrows() {
      if (!this.ready) return;
      const max = this.viewport.scrollWidth - this.viewport.clientWidth;
      const browsable = this.state === 'manual' || (this.state === 'held' && this.userPaused);
      const overflowing = browsable && max > 2;
      this.toggleAttribute('data-overflow', overflowing);
      const position = Math.abs(this.viewport.scrollLeft);
      // aria-disabled instead of disabled, so keyboard focus stays on the arrow at either end.
      if (this.prevButton) this.prevButton.setAttribute('aria-disabled', String(!overflowing || position <= 2));
      if (this.nextButton) this.nextButton.setAttribute('aria-disabled', String(!overflowing || position >= max - 2));
      if (this.controls) {
        const arrowsShown = overflowing && this.pointerQuery.matches;
        const toggleShown = Boolean(this.toggleButton) && !this.toggleButton.hidden;
        this.controls.hidden = !(arrowsShown || toggleShown);
      }
    }

    step(direction) {
      const button = direction < 0 ? this.prevButton : this.nextButton;
      if (button && button.getAttribute('aria-disabled') === 'true') return;
      const rtl = getComputedStyle(this).direction === 'rtl';
      const tile = this.originals[0].getBoundingClientRect().width / this.layoutScale();
      const amount = Math.max(tile, this.viewport.clientWidth * 0.8);
      this.viewport.scrollBy({
        left: direction * amount * (rtl ? -1 : 1),
        behavior: this.motionQuery.matches ? 'auto' : 'smooth'
      });
    }

    observeVideos() {
      if (this.videoObserver) this.videoObserver.disconnect();
      this.visibleVideos.clear();
      this.videos = Array.prototype.slice.call(this.track.querySelectorAll('video'));
      this.videos.forEach((video) => {
        video.muted = true;
        video.playsInline = true;
        if (this.videoObserver) this.videoObserver.observe(video);
      });
    }

    syncVideos() {
      // At the loop wrap each tile is replaced by the same tile one set further on.
      // Hand over the playback time so a visible video does not jump to another frame.
      if (this.state !== 'marquee' || this.sets < 2) return;
      const perSet = this.videos.length / this.sets;
      if (!perSet || perSet % 1) return;
      const now = performance.now();
      for (let i = 0; i + perSet < this.videos.length; i += 1) {
        const source = this.videos[i + perSet];
        const target = this.videos[i];
        if (source.readyState < 1) continue;
        if (target.readyState >= 1) {
          if (Math.abs(target.currentTime - source.currentTime) > 0.15) target.currentTime = source.currentTime;
          continue;
        }
        // Not loaded yet: browsers ignore a start time set now, so seek once the metadata is in.
        if (!target.irResume) {
          target.addEventListener('loadedmetadata', () => {
            const resume = target.irResume;
            target.irResume = null;
            if (!resume) return;
            const time = resume.time + (resume.playing ? (performance.now() - resume.at) / 1000 : 0);
            target.currentTime = target.duration ? time % target.duration : time;
          }, { once: true });
        }
        target.irResume = { time: source.currentTime, at: now, playing: !source.paused };
      }
    }

    updateVideos() {
      if (!this.ready) return;
      const allowed = !this.userPaused && this.onScreen;
      this.videos.forEach((video) => {
        if (allowed && this.visibleVideos.has(video)) {
          if (video.paused) {
            video.muted = true;
            const attempt = video.play();
            if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
          }
        } else if (!video.paused) {
          video.pause();
        }
      });
    }

    onFocusIn(event) {
      let keyboard = true;
      try {
        keyboard = event.target.matches(':focus-visible');
      } catch (error) {
        keyboard = true;
      }
      if (keyboard) this.hold('focus');
    }

    onFocusOut(event) {
      if (event.relatedTarget && this.viewport.contains(event.relatedTarget)) return;
      this.release('focus');
    }

    onTouchStart() {
      this.touching = true;
      clearTimeout(this.touchTimer);
      this.hold('touch');
    }

    onTouchEnd() {
      this.touching = false;
      this.queueTouchRelease();
    }

    queueTouchRelease() {
      clearTimeout(this.touchTimer);
      this.touchTimer = setTimeout(() => {
        if (!this.touching) this.release('touch');
      }, 1600);
    }

    onScroll() {
      if (this.holdReasons.has('touch') && !this.touching) this.queueTouchRelease();
      if ((this.state === 'manual' || this.state === 'held') && !this.arrowFrame) {
        this.arrowFrame = requestAnimationFrame(() => {
          this.arrowFrame = 0;
          this.updateArrows();
        });
      }
    }

    selectBlock(blockElement) {
      if (!this.ready) return;
      this.hold('editor');
      const scale = this.layoutScale();
      const viewportBox = this.viewport.getBoundingClientRect();
      const blockBox = blockElement.getBoundingClientRect();
      this.viewport.scrollBy({
        left: ((blockBox.left + blockBox.width / 2) - (viewportBox.left + viewportBox.width / 2)) / scale,
        behavior: this.motionQuery.matches ? 'auto' : 'smooth'
      });
    }

    deselectBlock() {
      if (this.ready) this.release('editor');
    }
  }

  window.customElements.define('insta-reel', InstaReel);

  const reelsIn = (target) => {
    if (!target || typeof target.querySelectorAll !== 'function') return [];
    return Array.prototype.slice.call(target.querySelectorAll('insta-reel'));
  };
  const reelFor = (target) => (target && typeof target.closest === 'function' ? target.closest('insta-reel') : null);

  document.addEventListener('shopify:section:load', (event) => {
    reelsIn(event.target).forEach((reel) => reel.init());
  });
  document.addEventListener('shopify:section:unload', (event) => {
    reelsIn(event.target).forEach((reel) => reel.destroy());
  });
  document.addEventListener('shopify:block:select', (event) => {
    const reel = reelFor(event.target);
    if (reel) reel.selectBlock(event.target);
  });
  document.addEventListener('shopify:block:deselect', (event) => {
    const reel = reelFor(event.target);
    if (reel) reel.deselectBlock();
  });
})();
// insta-reel:js:end

  } catch(e) { console.error(e); }
})();
})();
